const TapfiliateTracker = {

  _getTrackingId : function () {
    window.tap('getTrackingId', null, function(trackingId) {
      // Send tracking id to your backend and persist it
      // trackingId = 'a146f3e0-eeaf-11e9-837e-471c6af074a0'//'test'
      window.tapfiliateTrackingId = trackingId
    })
  },

  updateTrackingId: function() {
    if(TAPFILIATE){
      this._getTrackingId()
    }
  }
}

export default TapfiliateTracker
